<template>
  <LeafletMap />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import LeafletMap from '@/components/LeafletMap.vue';

export default defineComponent({
  name: 'Map',
  components: {
    LeafletMap,
  },
});
</script>
